module.exports = __webpack_public_path__ + "static/media/carousel-03.f3a888fd.png";